import {AiOutlineLinkedin} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'


const data = [
    {id:1, link: 'https://www.linkedin.com/in/kundanpaudel/', icon: <AiOutlineLinkedin/>},
    {id:1, link: 'https://github.com/kundanpaudel', icon: <AiFillGithub/>}
]

export default data